// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/1.0.0/" + chunkId + ".chunk.js";
};